<script lang="ts">
    /**
     * Share Modal to share catalog
     *
     */
    import { getContext } from "svelte";
    // FormMail
    import type { Operation } from "../model";
    import { SocialShareService } from "../services/SocialShareService";
    import { api } from "../stores";

    /**
     * Campaign
     */
    export let operation: Operation;

    const { open, close } = getContext("simple-modal");

    /**
     * Share catalog
     * @param sn: SocialNetwork choose
     */
    function shareVia(sn: SocialNetwork): void {
        let urlToShare = `${window.location.origin}/catalog/${
            operation.code
        }/${$api.getShopId()}`;

        switch (sn) {
            case SocialNetwork.TWITTER:
                window.open(
                    SocialShareService.twitterShareLink(
                        `Regarde ce catalogue (${operation.name}) : ${urlToShare}`
                    )
                );
                break;
            case SocialNetwork.WHATSAPP:
                // open url in new tab
                window.open(
                    SocialShareService.whatsappShareLink(
                        `Regarde ce catalogue : ${urlToShare}`
                    )
                );
                break;
            case SocialNetwork.LINKEDIN:
                // open url in new tab
                window.open(
                    SocialShareService.linkedinShareLink(
                        urlToShare,
                        operation.name,
                        "Regarde ce catalogue"
                    )
                );

                break;
            case SocialNetwork.FACEBOOK:
                // open url in new tab
                window.open(
                    SocialShareService.facebookShareLink(
                        urlToShare,
                        operation.name
                    )
                );
                break;
            // default:
        }
        close();
    }

    enum SocialNetwork {
        MAIL,
        WHATSAPP,
        LINKEDIN,
        FACEBOOK,
        TWITTER,
    }
</script>

<div class="wrapper">
    <div class="logo" on:click={() => shareVia(SocialNetwork.LINKEDIN)}>
        <i class="fab fa-linkedin-in" />
    </div>
    <div class="logo" on:click={() => shareVia(SocialNetwork.WHATSAPP)}>
        <i class="fab fa-whatsapp" />
    </div>
    <div class="logo" on:click={() => shareVia(SocialNetwork.TWITTER)}>
        <i class="fab fa-twitter" />
    </div>
    <div class="logo" on:click={() => shareVia(SocialNetwork.FACEBOOK)}>
        <i class="fab fa-facebook-f" />
    </div>
</div>

<style lang="scss">
    @import "../styles/variables";

    .wrapper {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        @media (max-width: $mobile-breakpoint) {
            flex-direction: column;
        }
        a {
            color: #fff;
        }
        .logo {
            font-size: 2rem;
            display: inline-block;
            cursor: pointer;
            margin: 15px;
            width: 80px;
            height: 80px;
            line-height: 80px;
            border-radius: 50%;
            text-align: center;
            position: relative;
            color: #fff;
            background-color: rgba(255, 255, 255, 0.1);
            transition: 300ms;
            &:after {
                pointer-events: none;
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                content: "";
                box-sizing: content-box;
                box-shadow: 0 0 0 3px #fff;
                top: 0;
                left: 0;
                opacity: 0;
                transition: 300ms;
            }
            &:hover {
                background-color: #fff;
                color: #151515;
            }
            &:hover:after {
                opacity: 1;
                transform: scale(1.15);
            }
        }
    }
</style>
